/**
 * DecisionIcon/index.js
 * desc: system icon for decision step type
 * note: entity icon via IconButton; defaults its tooltip + accessible name to the
 *       icon label. Renders an accessible button when given an onClick handler.
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const DecisionIcon = ({ tooltip, ...props }) => (
    <IconButton
        baseClassName="decision icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.decision.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg"><path d="M0 18h6.75l-2.576-2.576 5.951-5.963V0h-2.25v8.539l-5.299 5.287L0 11.25V18zm13.826-2.576L11.25 18H18v-6.75l-2.576 2.576-3.24-3.24-1.598 1.598 3.24 3.24z"/></svg>
    </IconButton>
);


export default DecisionIcon;
